<template>
  <div
    class="question"
    >
    <span v-if="botStatus !=='REMAINING_FAMILY_MEMBERS'">
      {{ t(`chatbot_${questionId}`, {topic: t(`chatbot_topic_${this.topic}`)}) }}
    </span>
    <span v-else> {{ t('chatbot_ask_another_question') }} </span>
  </div>
</template>

<script>
import { get } from 'lodash'
import { useI36n } from '@jota-one/i36n/src/index.vue2'
import { ref } from '@vue/composition-api'

export default {
  name: 'ChatBotQuestion',
  components: {},
  props: {
    message: {
      type: Object,
      default: () => ({})
    }
  },

  setup (props) {
    const { $label: t } = useI36n()
    const questionId = ref(props.message.botPayload.question.questionId)
    const botStatus = ref(props.message.botStatus)
    const topic = ref(get(props.message, 'botPayload.context.topic'))

    return {
      t,
      questionId,
      botStatus,
      topic
    }
  }
}
</script>

<style scoped lang="postcss">
  .question {
    &.satisfied {
      color: var(--tw-c-original-green)
    }
  }
</style>
